/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const groceryBudget = useStore((state) => state.groceryBudget);
  const setGroceryBudget = useStore((state) => state.setGroceryBudget);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.groceryBudget.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.groceryBudget.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={groceryBudget}
          onChange={(value) => {
            setGroceryBudget(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'grocery-budget',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Under $75'}>
            <span>💰</span> {t('onboarding.groceryBudget.options.under75')}
          </Option>
          <Option value={'$75–$150'}>
            <span>💵</span> {t('onboarding.groceryBudget.options.75to150')}
          </Option>
          <Option value={'$150–$250'}>
            <span>💳</span> {t('onboarding.groceryBudget.options.150to250')}
          </Option>
          <Option value={'Over $250'}>
            <span>🛒</span> {t('onboarding.groceryBudget.options.over250')}
          </Option>
          <Option value={'Not sure'}>
            <span>🤔</span> {t('onboarding.groceryBudget.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
